// extracted by mini-css-extract-plugin
export default {"subFooter":"SubFooter_subFooter__T041y","left":"SubFooter_left__QD3E-","right":"SubFooter_right__wVdFx"};